var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyllabus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#F7941E",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 2h-7V1a1 1 0 1 0-2 0v1H1a1 1 0 1 0 0 2v3.57c0 .887.273 1.752.78 2.48.164.232.348.45.55.65.202.201.423.382.66.54.232.162.48.3.74.41.527.23 1.095.35 1.67.35H8v2.03l-2.64 2.2c-.421.356-.48.983-.13 1.41A.99.99 0 0 0 6 18c.233-.002.46-.083.64-.23L8 16.64V17a1 1 0 0 0 2 0v-.36l1.36 1.13c.18.147.407.228.64.23a.99.99 0 0 0 .77-.36 1.009 1.009 0 0 0-.13-1.41L10 14.03V12h2.62a4 4 0 0 0 1.65-.35 4.1 4.1 0 0 0 .74-.41c.237-.158.458-.339.66-.54.202-.204.386-.424.55-.66.507-.724.78-1.586.78-2.47V4a1 1 0 0 0 0-2zm-6 8H7a1 1 0 1 1 0-2h4a1 1 0 0 1 0 2zm3-4H4a1 1 0 1 1 0-2h10a1 1 0 0 1 0 2z",
    fill: "#F7941E",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyllabus);
export default __webpack_public_path__ + "static/media/syllabus.38ae01ca18fa99fc1ae0b7f0419ea4f1.svg";
export { ForwardRef as ReactComponent };